module.exports = __webpack_public_path__ + "img/kachel_aloevia_SPECIALCARE.49498348.png";